import { AdaptiveCard, HostConfig } from "adaptivecards";
import MarkdownIt from "markdown-it";
import { type FC, useEffect, useRef } from "react";
import { useAccountBrand } from "../../../../../../../generic/hooks/use-account-brand";
import { TeamsMessageSender } from "./teams-sender";
import { teamsHostConfig } from "./teams-wrapper-config";
import "./teams-wrapper.css";

export const TeamsWrapper: FC<{
  card: Parameters<AdaptiveCard["parse"]>[0];
}> = ({ card }) => {
  const cardRef = useRef<HTMLDivElement>(null);

  const { data: accountData } = useAccountBrand();

  useEffect(() => {
    if (!cardRef.current || !card) return;

    // Clear previous content
    cardRef.current.innerHTML = "";

    // Create adaptive card instance
    const adaptiveCard = new AdaptiveCard();

    // Apply Teams host config
    adaptiveCard.hostConfig = new HostConfig(teamsHostConfig);

    adaptiveCard.onExecuteAction = (action) => {
      if (action.getHref()) {
        window.open(action.getHref(), "_blank");
      }
    };

    // Parse the card payload
    adaptiveCard.parse(card);

    const markdownProcessor = new MarkdownIt();
    const defaultRender =
      markdownProcessor.renderer.rules.link_open ||
      function (tokens, idx, options, env, self) {
        return self.renderToken(tokens, idx, options);
      };

    markdownProcessor.renderer.rules.link_open = function (tokens, idx, options, env, self) {
      tokens[idx]!.attrPush(["target", "_blank"]);
      tokens[idx]!.attrPush(["rel", "noopener noreferrer"]);
      return defaultRender(tokens, idx, options, env, self);
    };

    AdaptiveCard.onProcessMarkdown = (text, result) => {
      result.outputHtml = markdownProcessor.render(text);
      result.didProcess = true;
    };

    // Render the card to the div
    const renderedCard = adaptiveCard.render();
    if (renderedCard) {
      cardRef.current.appendChild(renderedCard);
    }
  }, [card]);

  return (
    <div className="teams-preview-capture-area">
      <TeamsMessageSender
        sender={
          accountData
            ? {
                name: accountData.name,
                avatarSrc: accountData.logo,
              }
            : undefined
        }
      >
        <div
          className="teams-adaptive-card-container"
          ref={cardRef}
          data-testid="preview-teams-container"
        />
      </TeamsMessageSender>
    </div>
  );
};
